export default __webpack_public_path__ + "static/media/jessicapeony_ten.53c28322.JPG";